// ================= About & General =================
import Aboutimg from "../assets/aboutimg.png";
import Abouts from "../assets/abouts.png";
import Anand from "../assets/anand.jpeg";
import Android from "../assets/android-3.jpg";
import Anshumali from "../assets/anshumali.jpeg";
import Anu from "../assets/anu.jpeg";
import AppDevelop from "../assets/appdevlop.png";
// import Bannar1 from "../assets/banner1.png";
// import Bannar2 from "../assets/banner2.png";
// import Bannar3 from "../assets/banner3.png";
import Blog from "../assets/blog.png";
import BuyOnline from "../assets/buy-online.svg";
import Communicate from "../assets/communicate.svg";
import CommonBanner from "../assets/commonbarrer.gif";

import Dana from "../assets/Dana.jpeg";
import DesignTools from "../assets/design-tools.svg";
import Ecommerce from "../assets/ecommerce.png";
import Gig from "../assets/gif-4mb.gif";
import How from "../assets/how.png";
import Image from "../assets/image.png";

// ================= Common Images =================
import Img1 from "../assets/img1.png";
import Img2 from "../assets/img2.svg";
import Img3 from "../assets/img3.svg";
import Img4 from "../assets/img4.svg";
import Img5 from "../assets/img5.svg";
import Img6 from "../assets/img6.jpg";
import Img7 from "../assets/img7.jpg";
import Img8 from "../assets/img8.png";
import Img9 from "../assets/img9.svg";
import Img10 from "../assets/img10.jpg";
import Img11 from "../assets/img11.jpg";
import Img12 from "../assets/img12.jpg";

import Kamna from "../assets/kamna.jpeg";
import Language from "../assets/language.png";
import Logocompany from "../assets/logocompany.png";
import Logocompany1 from "../assets/logocompany1.png";
import Maintenancebg from "../assets/maintenancebg.png";
import Manaya from "../assets/manya.jpeg";
import MobileApp from "../assets/mobile-app.svg";
import MobileAppBg from "../assets/mobileappbg.png";
import Nasrat from "../assets/nasrat.jpeg";
import Nilanjana from "../assets/nilanjana.png";
import ProjectStart from "../assets/projectstart.png";
import Rahul from "../assets/rahul.jpeg";
import RahulSingh from "../assets/rahulsingh.jpg";
import Redesign from "../assets/redesign.png";

import SeoBg from "../assets/seobg.png";

import Sneha from "../assets/sneha.jpg";

import SoftwareTraining from "../assets/softwaretraining.png";
import Training from "../assets/training.png";
import Uibg from "../assets/uibg.png";
import Vinit from "../assets/vinit.jpeg";
import Website from "../assets/website.svg";
import What from "../assets/what.webp";
import Who from "../assets/who.jpg";

// ================= Recent Projects =================
import Afgram from "../assets/recentproject/afgram.jpeg";
import Architecture from "../assets/recentproject/architecure.jpg";
import Aws from "../assets/recentproject/aws.png";
import Azure from "../assets/recentproject/azure.jpg";
import Goverment from "../assets/recentproject/government.jpg";
import ShreddersBay from "../assets/recentproject/shreddersbay.jpg";

// ================= Technologies =================
import Ai from "../assets/Technologies/ai.png";
import AiMl from "../assets/Technologies/ai-ml.png";
import ApiDev from "../assets/Technologies/api-dev.png";
import Angular from "../assets/Technologies/angular.png";
import AppDeveloperBanner from "../assets/Technologies/app-developer-banner-variation.png";
import Apple from "../assets/Technologies/apple.jpeg";
import BackendImg from "../assets/Technologies/backendImg.png";
import Bootstrap from "../assets/Technologies/bootstrap.png";
import Browserstack from "../assets/Technologies/browserstack.jpg";
import Cassandra from "../assets/Technologies/cassandra.png";
import Cloud from "../assets/Technologies/cloud.png";
import CloudDev from "../assets/Technologies/cloud-dev.png";
import CrossPlatform from "../assets/Technologies/Cross-Platform.jpg";
import Css from "../assets/Technologies/css.png";
import CustumSoftwareBg from "../assets/Technologies/custom-software.jpg";
import CustomWebAppImg from "../assets/Technologies/customWebAppImg.jpg";
import Designprototypin from "../assets/Technologies/designprototypin.jpg";
import Docker from "../assets/Technologies/docker.png";
import Dotnet from "../assets/Technologies/dotnet.png";
import Download from "../assets/Technologies/download.png";
import Dynamo from "../assets/Technologies/dynamo.png";
import EcommerceImg from "../assets/Technologies/ecommerceImg.jpg";
import Elastic from "../assets/Technologies/elastic.png";
import Figma from "../assets/Technologies/figma.png";
import Flutter from "../assets/Technologies/flutter.png";
import Framer from "../assets/Technologies/framer.jpg";
import FrontendImg from "../assets/Technologies/frontendImg.jpg";
import Gcp from "../assets/Technologies/gcp.png";
import Html from "../assets/Technologies/html.jpg";
import Illustrator from "../assets/Technologies/illustrator.png";
import InDesign from "../assets/Technologies/indesign.png";
import Ionic from "../assets/Technologies/ionic.png";
import Ios from "../assets/Technologies/ios.png";
import Java from "../assets/Technologies/java.png";
import Jenkins from "../assets/Technologies/jenkins.png";
import Jira from "../assets/Technologies/jira.jpg";
import Jmeter from "../assets/Technologies/jmeter.png";
import Junit from "../assets/Technologies/junit.png";
import Kubernetes from "../assets/Technologies/kubernetes.png";
import Laravel from "../assets/Technologies/laravel.png";
import Magento from "../assets/Technologies/magento.png";
import MaintenanceSupport from "../assets/Technologies/maintenance-support.jpg";
import Meet from "../assets/Technologies/meet.png";
import Mongo from "../assets/Technologies/mongo.png";
import Mysql from "../assets/Technologies/mysql.png";
import NativeDevelopment from "../assets/Technologies/nativedevelopment.jpg";
import Node from "../assets/Technologies/node.png";
import Oracel from "../assets/Technologies/oracle.png";
import Photoshop from "../assets/Technologies/photoshop.png";
import Php from "../assets/Technologies/php.png";
import Postgres from "../assets/Technologies/postgres.png";
import Postman from "../assets/Technologies/postman.png";
import PowerBi from "../assets/Technologies/powerbi.png";
import PWebAppImg from "../assets/Technologies/progressiveWebAppsImg.png";
import Python from "../assets/Technologies/python.jpg";
import Rails from "../assets/Technologies/rails.jpg";
import React from "../assets/Technologies/react.png";
import ReactLogo from "../assets/Technologies/reactLogo.png";
import ReactNative from "../assets/Technologies/react-native.jpg";
import ReactNative2 from "../assets/Technologies/reactnative.png";
import Saas from "../assets/Technologies/saas.png";
import SalesForce from "../assets/Technologies/salesforce.png";
import Sap from "../assets/Technologies/sap.jpg";
import Selenium from "../assets/Technologies/selenium.png";
import SharePoint from "../assets/Technologies/sharepoint.png";
import Shopify from "../assets/Technologies/shopify.png";
import Sketch from "../assets/Technologies/sketch.png";
import Slack from "../assets/Technologies/slack.png";
import SoftwareIntegration from "../assets/Technologies/software-integration.png";
import Sql from "../assets/Technologies/sql.jpg";
import Tableau from "../assets/Technologies/tableau.png";
import Teams from "../assets/Technologies/teams.jpg";
import Technologies from "../assets/Technologies/technologies.png";
import Testrail from "../assets/Technologies/testrail.png";
import Trello from "../assets/Technologies/trello.png";
import Vue from "../assets/Technologies/vue.jpg";
import Webdevelop from "../assets/Technologies/Webdevelop.png";
import Wordpress from "../assets/Technologies/wordpress.png";
import Zoom from "../assets/Technologies/zoom.png";
import Trainingbgg from "../assets/trainingbg.gif"

// ================= EXPORT =================
export const ImagesApp = {
  Aboutimg,
  Trainingbgg,
  Abouts,
  Anand,
  Android,
  Anshumali,
  Angular,
  Anu,
  AppDevelop,
  // Bannar1,
  // Bannar2,
  // Bannar3,
  Blog,
  BuyOnline,
  Communicate,
  CommonBanner,

  Dana,
  DesignTools,
  Ecommerce,
  Gig,
  How,
  Image,
  Img1,
  Img2,
  Img3,
  Img4,
  Img5,
  Img6,
  Img7,
  Img8,
  Img9,
  Img10,
  Img11,
  Img12,
  Kamna,
  Language,
  Logocompany,
  Logocompany1,
  Maintenancebg,
  Manaya,
  MobileApp,
  MobileAppBg,
  Nasrat,
  Nilanjana,
  ProjectStart,
  Rahul,
  RahulSingh,
  Redesign,

  SeoBg,

  Sneha,

  SoftwareTraining,
  Training,
  Uibg,
  Vinit,
  Website,
  What,
  Who,
  Afgram,
  Architecture,
  Aws,
  Azure,
  Goverment,
  ShreddersBay,
  Ai,
  AiMl,
  ApiDev,
  AppDeveloperBanner,
  Apple,
  BackendImg,
  Bootstrap,
  Browserstack,
  Cassandra,
  Cloud,
  CloudDev,
  CrossPlatform,
  Css,
  CustumSoftwareBg,
  CustomWebAppImg,
  Designprototypin,
  Docker,
  Dotnet,
  Download,
  Dynamo,
  EcommerceImg,
  Elastic,
  Figma,
  Flutter,
  Framer,
  FrontendImg,
  Gcp,
  Html,
  Illustrator,
  InDesign,
  Ionic,
  Ios,
  Java,
  Jenkins,
  Jira,
  Jmeter,
  Junit,
  Kubernetes,
  Laravel,
  Magento,
  MaintenanceSupport,
  Meet,
  Mongo,
  Mysql,
  NativeDevelopment,
  Node,
  Oracel,
  Photoshop,
  Php,
  Postgres,
  Postman,
  PowerBi,
  PWebAppImg,
  Python,
  Rails,
  React,
  ReactLogo,
  ReactNative,
  ReactNative2,
  Saas,
  SalesForce,
  Sap,
  Selenium,
  SharePoint,
  Shopify,
  Sketch,
  Slack,
  SoftwareIntegration,
  Sql,
  Tableau,
  Teams,
  Technologies,
  Testrail,
  Trello,
  Vue,
  Webdevelop,
  Wordpress,
  Zoom,
};
